<template>
  <div class="mb-10 lg:mb-2 text-xs">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <Breadcrumbs :breadcrumbs="categoryBreadcrumbs" />
  </div>
</template>

<script lang="ts" setup>
import * as qs from 'qs'
import type { EventDescription } from '~/composables/types/event'
import type { StrapiEventListPage } from '~/composables/types/strapiEventListPage'
import Link from '~/components/common/Link.vue'

const props = withDefaults(
  defineProps<{
    eventDetail: Ref<EventDescription> | null
    isGiftcard: boolean
  }>(),
  {
    eventDetail: null,
    isGiftcard: false,
  }
)
const { locale } = useI18n()

const eventData = toRef(() => props.eventDetail)

const useStrapiCityCategory = async (
  type: string,
  citySlug: string,
  categorySlug: string | null
) =>
  await useStrapiSingleType<StrapiEventListPage>(
    `event-list-pages/?${qs.stringify(
      {
        locale: convertLocaleIntoBCP47(locale.value),
        fields: ['title'],
        filters: {
          type: {
            $eq: type,
          },
          citySlug: {
            $eq: citySlug,
          },
          categorySlug: {
            ...(categorySlug
              ? {
                  $eq: categorySlug,
                }
              : {
                  $null: true,
                }),
          },
        },
      },
      {
        encode: false,
      }
    )}`,
    {
      // query: { locale },
      transform: ({ data }) => data?.[0] || {},
      default: () => [],
      onResponseError: (err) => {
        console.log('onResponseError', err)
      },
    }
  )
const [{ data: cityData }, { data: cityCategoryData }] = props.isGiftcard
  ? [{ data: [] }, { data: [] }]
  : await Promise.all([
      useStrapiCityCategory(
        'city',
        eventGetters.getAddressLocality(eventData.value).slug,
        null
      ),
      useStrapiCityCategory(
        'city-category',
        eventGetters.getAddressLocality(eventData.value).slug,
        eventGetters.getMainCategorySlug(eventData.value)
      ),
    ])

const { breadcrumbs, categoryBreadcrumbs } = useEventBreadcrumbs(
  props.isGiftcard,
  {
    eventData,
    cityData,
    cityCategoryData,
  }
)
</script>

<style></style>
